var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#tg_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#tg_svg__b)",
  d: "M12 0a11.999 11.999 0 0 0-8.484 20.485 11.999 11.999 0 1 0 16.968-16.97A12 12 0 0 0 12 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.432 11.873a583 583 0 0 1 6.997-3.014c3.334-1.386 4.026-1.627 4.478-1.635.1-.002.32.023.465.14.12.098.154.231.17.325.015.093.036.306.02.472-.18 1.897-.963 6.502-1.36 8.627-.167.9-.499 1.201-.82 1.23-.697.065-1.226-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.248-2.977 3.306-3.23.008-.032.015-.15-.056-.212-.07-.063-.173-.041-.248-.024q-.159.036-5.062 3.345-.716.495-1.301.481c-.428-.01-1.253-.242-1.866-.441-.75-.245-1.348-.374-1.296-.789q.04-.324.893-.663"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "tg_svg__b",
  x1: 1200,
  x2: 1200,
  y1: 0,
  y2: 2400,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2AABEE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#229ED9"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "tg_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgTg;